import React from 'react';
import { cn } from '@/utils';
import { t } from '@lingui/macro';

import { ButtonWithLogo } from '@/components/common/ButtonWithLogo/ButtonWithLogo';

type Props = {
  onCancel: () => void;
  onConfirm?: () => void;
  disabled?: boolean;
  className?: string;
  showCancel?: boolean;
  showConfirm?: boolean;
};

const SaveCancelButtons = ({
  onCancel,
  onConfirm,
  className,
  showCancel = true,
  disabled = false,
  showConfirm = true,
}: Props) => {
  return (
    <div className={cn(`flex flex-row items-center gap-x-6 bg-white px-10 py-7`, className)}>
      {showCancel && (
        <ButtonWithLogo
          type="button"
          onClick={onCancel}
          nameButton={'Cancelar y salir'}
          className="cancel-button min-w-[165px] justify-center"
        />
      )}
      {showConfirm && (
        <ButtonWithLogo
          onClick={onConfirm}
          nameButton={'Guardar cambios'}
          type="submit"
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default SaveCancelButtons;
